export type Option<T> = {
  value: T;
  label: string;
};

export function getEnumName(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  enumeration: any,
  value: string | undefined
): string | undefined {
  if (!value) {
    return undefined;
  }

  const index = Object.values(enumeration).indexOf(value);
  if (index < 0) {
    return undefined;
  }

  return Object.keys(enumeration)[index];
}
